import InfoLayout from "./InfoLayout";

function Compatibility() {
  return (
    <InfoLayout title="Kompatibilita">
      <p>
        <strong>Tabata časovač</strong> je primárně navržen pro desktopové prostředí – ideální pro
        počítače, monitory, notebooky a televizory. Díky tomu získáte plnohodnotný uživatelský
        zážitek s přehledným rozhraním.
      </p>

      <p>
        Aplikaci lze spustit i na tabletech nebo mobilních telefonech. Na menších displejích může
        být uživatelský zážitek omezen velikostí obrazovky, ale i zde je aplikace plně funkční. Stačí
        zadat webovou adresu do prohlížeče – <strong>žádná instalace ani registrace</strong> není
        potřeba.
      </p>

      <h2 className="text-xl font-semibold mt-4">Rozlišení a zobrazení</h2>
      <p>
        Aplikace je optimalizována pro klasické Full HD rozlišení televizorů a monitory s rozlišením
        1920×1200. U jiných rozlišení může být nutné jemné scrollování, aby byl obsah kompletně
        viditelný.
      </p>

      <h2 className="text-xl font-semibold mt-4">Doporučené prohlížeče</h2>
      <p>
        Pro nejlepší zážitek doporučujeme používat Google Chrome nebo Microsoft Edge, na kterých byla
        aplikace testována a optimalizována. Aplikace by však měla fungovat bez problémů i v jiných
        moderních prohlížečích.
      </p>

      <h2 className="text-xl font-semibold mt-4">Výkon zařízení</h2>
      <p>
        <strong>Tabata časovač</strong> je nenáročný na výkon a lze jej spustit na všech standardních
        počítačích, noteboocích, tabletech i mobilních telefonech.
      </p>

      <h2 className="text-xl font-semibold mt-4">Spuštění na mobilních systémech</h2>
      <p>
        Aplikace je kompatibilní s Android a iOS. U některých mobilních zařízení může během cvičení
        dojít k přepnutí telefonu do režimu spánku. Tabata časovač je navržen tak, aby k tomuto
        nedocházelo. Pokud se však tato situace objeví, jednoduchým řešením je prodloužit dobu,
        po kterou telefon přechází do spánku.
      </p>
    </InfoLayout>
  );
}

export default Compatibility;
